import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { some } from 'lodash'

import { saveUserShortcuts, updateUserRole } from '@/stores/slices/Labeling/thunks/misc'
import { LabelingState } from '@/stores/slices/Labeling/types'

export const miscExtraReducers = (builder: ActionReducerMapBuilder<LabelingState>) => {
  builder.addCase(saveUserShortcuts.fulfilled, (state, action) => {
    state.userShortcuts = action.payload.shortCutKeySettings
  })
  builder.addCase(updateUserRole.fulfilled, (state, action) => {
    const { labelingMembers, reviewers, userId } = action.payload

    state.reviewers = reviewers
    state.labelingMembers = labelingMembers
    state.userIsReviewer = some(reviewers, { userId })
    state.userIsLabeler = some(labelingMembers, { userId })
  })
}
